import React from 'react';
import './Impressum.css';

const Impressum = () => {
    return (
      <div className="impressum" id='impressum'>
        <h1>Impressum</h1>
        <p><strong>Delta Tank GmbH</strong></p>
        <p>Kleiststr. 12<br />44147 Dortmund</p>
  
        <h2>Vertreten durch:</h2>
        <p>Abdilaziz Alabeid</p>
  
        <h2>Kontakt:</h2>
        <p>Telefon: 0177 2266118<br />E-Mail: info@delta-tank.de</p>
  
        <h2>Registereintrag:</h2>
        <p>Eintragung im Handelsregister.<br />Registergericht: 44135 Dortmund<br />Registernummer: HRB 36167</p>
  
        {/*<h2>Umsatzsteuer-ID:</h2>
        <p>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE123456789</p>*/}
  
        
      </div>
    );
  }
  
  export default Impressum;